import { ModifyStore, handleStoreState } from "Stores/RESTStore/CoreStore";
import { API } from "General/API";
import { action, makeObservable } from "mobx";
import { DataStore } from "Stores/RESTStore/DataStore";
import { ListStore } from "Stores/RESTStore/ListStore";

export abstract class EditStore<T> extends ModifyStore<T> {
  dataStore: DataStore<object>;
  sourceDataFields: string[];

  constructor(dataStore: DataStore<object>, listStore: ListStore<T> = undefined, identifier = "id") {
    super(listStore, identifier);
    makeObservable(this, {
      save: action.bound,
    });

    this.dataStore = dataStore;
    this.dataStore.registerEditStore(this as unknown as EditStore<object>);
  }

  clear() {
    if (this.dataStore) {
      this.data = this.dataStore.data as T;
    } else {
      this.data = {} as T;
    }
  }

  setData(data: object) {
    if (this.sourceDataFields) {
      this.sourceDataFields.forEach((val) => {
        if (data[val]) {
          this.update({ val: data[val] });
        }
      });
      this.update({ [this.identifier]: data[this.identifier] });
    } else {
      this.update(data);
    }
  }

  @handleStoreState()
  async save() {
    let url = this.url();
    const id = this.data[this.identifier];
    if (id) {
      url = this.url(id);
    }
    this.saveResult = await API.editData(url, this.data);
    // FIXME: saveResult should have a specific structure and that should be used to update the list.
    this.updateList();
  }
}
